export default {
  nav: {
    Down: "Download",
    ReserveGift: "Pre-register for gifts",
    CharacterIntroduction: "Character introduction",
    Gameplay: "Gameplay introduction",
    AttentionFB: "Special recharge offer",
  },
  news: {
    NextPage: "Halaman Berikutnya",
    PrevPage: "Halaman Sebelumnya",
    NextContent: "Postingan Berikut",
    PrevContent: "Postingan Sebelumnya",
    Return: "Kembali",
    ReturnList: "Kembali ke List",
    More: "Lainnya",
    None: "goTidak ada lagi",
  },
};
